<div class="custom-dialog-wrapper">
  <h1 mat-dialog-title class="custom-dialog-title">Add Vendor</h1>
  <div mat-dialog-content>
    <mat-stepper #stepper class="stepper-container"
      [ngClass]="{ 'hide-stepper': purchaseType !== 'tender' && purchaseType !== 'dc' }">
      <mat-step [label]="stepperLabels.SELECT_VENDORS">
        <p class="mb-2">Unable to find the vendor you want or need help doing so?</p>
        <p class="mb-4">
          <span class="link" tabindex="0" (keypress)="goCreateVendor()" (click)="goCreateVendor()">
            Create a new vendor in MMS
          </span>
          or download the
          <span class="link" tabindex="0" (keypress)="ACLASL()" (click)="ACLASL()">
            approved contractor/supplier list
          </span>
        </p>
        <div class="searchBar">
          <div class="search-bar-container">
            <div class="input-group">
              <mat-form-field appearance="fill">
                <mat-icon matPrefix>search</mat-icon>
                <input type="text" matInput placeholder="Search vendor name" (keydown.enter)="basicSearchClickHandler()"
                  [(ngModel)]="vendorSearchInput" />
              </mat-form-field>
            </div>
            <app-button class="search-button" name="Search" type="flat-button" tabindex="0"
              (keypress)="basicSearchClickHandler()" (click)="basicSearchClickHandler()"></app-button>

              <app-button class="advanced-search-button" name="Advanced Search"
              (click)="openAdvSearchDialog()"></app-button>
          </div>

          <!-- search table -->
          <div class="custom-table-wrapper--inner custom-table-wrapper--scroll-within" *ngIf="vendorDataSource.data.length > 0">
            <table mat-table [dataSource]="vendorDataSource" class="mat-elevation-z8 search-data-table">
              <!-- Checkbox Column -->
              <ng-container matColumnDef="sSelect">
                <th mat-header-cell *matHeaderCellDef class="checkbox-cell">
                  <mat-checkbox (change)="$event ? masterVToggle() : null"
                    [checked]="vendorSelection.hasValue() && isAllVSelected()"
                    [indeterminate]="vendorSelection.hasValue() && isAllVSelected()">
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row" class="checkbox-cell">
                  <!-- <div [tp]="tooltipTemplateDisableVendorSelect" tpClassName="custom-tooltip" tpMaxWidth="300px"
                    [tpInteractive]="true" tpPlacement="top" [tpIsEnabled]="isDisabled(row)"> -->
                    <mat-checkbox tabindex="0" (keypress)="$event.stopPropagation()" (click)="$event.stopPropagation()"
                      [disabled]="isDisabled(row)" (change)="$event ? vendorSelection.toggle(row) : null"
                      [checked]="vendorSelection.isSelected(row)">
                    </mat-checkbox>
                  <!-- </div> -->
                </td>
              </ng-container>
              <ng-container *ngFor="let column of searchDisplayedCols">
                <ng-container matColumnDef="{{ column }}" *ngIf="column == 'Name'">
                  <th mat-header-cell *matHeaderCellDef>Vendor Name</th>
                  <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
                </ng-container>
                <ng-container matColumnDef="{{ column }}" *ngIf="column == 'VendorContactPersonFullName'">
                  <th mat-header-cell *matHeaderCellDef>Contact person</th>
                  <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
                </ng-container>
                <ng-container matColumnDef="{{ column }}" *ngIf="column == 'VendorNumber'">
                  <th mat-header-cell *matHeaderCellDef>Vendor no.</th>
                  <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
                </ng-container>
                <ng-container matColumnDef="{{ column }}" *ngIf="column == 'AddressCountryCode'">
                  <th mat-header-cell *matHeaderCellDef>Country</th>
                  <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
                </ng-container>
                <ng-container matColumnDef="{{ column }}" *ngIf="column == 'EmailAddress'">
                  <th mat-header-cell *matHeaderCellDef class="email-tooltip">
                    <span>Email</span>
                    <mat-icon class="mx-1 d-inline-block" [matTooltip]="'RFQ released will be sent to the selected email.'"
                      matTooltipClass="mat-custom-tooltip">help</mat-icon>
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
                </ng-container>
                <ng-container matColumnDef="{{ column }}" *ngIf="column == 'VendorStatus'">
                  <th mat-header-cell *matHeaderCellDef>Vendor Status</th>
                  <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
                </ng-container>
                <ng-container matColumnDef="{{ column }}" *ngIf="column == 'IsPerm'">
                  <th mat-header-cell *matHeaderCellDef>Vendor Type</th>
                  <td mat-cell *matCellDef="let element">{{ element[column]? 'Permanent':'Temporary' }}</td>
                </ng-container>
                <!--<ng-container
                matColumnDef="{{ column }}"
                *ngIf="column == 'Justification' && (purchaseType === 'tender' || purchaseType === 'dc')"
              >
                <th mat-header-cell *matHeaderCellDef>Justification</th>
                <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
              </ng-container>-->
              </ng-container>
              <ng-template #tooltipTemplateDisableVendorSelect>
                <div class="custom-tooltip">
                  <p>
                    This vendor cannot be selected as it is either inactive, suspended, or banned.
                    <br />
                    <br />
                    Selection of temporary vendor is only allowed for Corporate Credit Card purchases. For all other
                    purchase modes, please approach PMM to convert the status to permanent for selection.
                  </p>
                </div>
              </ng-template>

              <tr mat-header-row *matHeaderRowDef="searchDisplayedCols"></tr>
              <tr mat-row *matRowDef="let row; columns: searchDisplayedCols"
                [ngClass]="{ 'custom-table-row--disabled': isDisabled(row) }"
                [matTooltip]="isDisabled(row) ? 'This vendor cannot be selected as it is either inactive, suspended, or banned.  Selection of temporary vendor is only allowed for Corporate Credit Card purchases. For all other purchase modes, please approach PMM to convert the status to permanent for selection.' : ''"  matTooltipClass="mat-custom-tooltip" ></tr>
            </table>
          </div>
          <mat-paginator class="custom-table-paginator" #searchPg [length]="totalCount" [pageSize]="pageSize"
          [pageIndex]="isAdvancedSearch ? currentPageAdvance : currentPage" [pageSizeOptions]="pageSizeOptions"
          (page)="onSearchPageChange($event)" showFirstLastButtons *ngIf="vendorDataSource.data.length > 0">
        </mat-paginator>
        </div>
        <div style="padding-top:20px">
          <shared-alert [type]="alertType.Error" *ngIf="duplicateFound">
            <p alert-content class="my-1">Duplicate entry detected. Please remove the duplicate and try again.</p>
          </shared-alert>
        </div>
      </mat-step>
      <mat-step [label]="stepperLabels.INPUT_JUSTIFICATION" *ngIf="purchaseType === 'tender' || purchaseType === 'dc'">
        <div class="justification-label">
          Please input your justifications for the selected vendor
        </div>
        <div *ngIf="isErrorJustification" class="justification-error">
          <mat-icon class="icon">info</mat-icon>
          <span>Please ensure that all vendor justification is filled.</span>
        </div>
        <div *ngFor="let vendor of vendorSelection.selected">
          <app-input-justification [vendor]="vendor" [Justification]="vendor?.Justification || ''"
            [isError]="!!isErrorJustification"></app-input-justification>
        </div>
      </mat-step>
    </mat-stepper>
  </div>
  <div mat-dialog-actions class="custom-dialog-buttons">
    <ng-container *ngIf="!stepper || !stepper.selected || stepper.selected.label === stepperLabels.SELECT_VENDORS">
      <app-button class="padBtn cancel-button" name="Cancel" tabindex="0" (keypress)="dialogRef.close()"
        (click)="dialogRef.close()"></app-button>
      <button mat-button class="padBtn secondary-button" class="primary-button" mat-flat-button (keypress)="stepper.next()"
        (click)="stepper.next()" *ngIf="purchaseType === 'tender' || purchaseType === 'dc'">
        Next
      </button>
      <app-button class="padBtn action-button" name="Add" type="flat-button" tabindex="0" (keypress)="addVendor()"
        (click)="addVendor()" *ngIf="purchaseType !== 'tender' && purchaseType !== 'dc'"></app-button>
  
    </ng-container>
    <ng-container *ngIf="stepper?.selected?.label === stepperLabels.INPUT_JUSTIFICATION">
      <app-button class="padBtn cancel-button" name="Cancel" tabindex="0" (keypress)="dialogRef.close()"
        (click)="dialogRef.close()">></app-button>
      <button mat-button class="padBtn secondary-button"  mat-stroked-button
        (keypress)="stepper.previous()" (click)="stepper.previous()">
        Previous
      </button>
      <app-button class="padBtn action-button" name="Add" type="flat-button" tabindex="0"
        (keypress)="addVendor(); stepper.reset()" (click)="addVendor(); stepper.reset()"></app-button>
    </ng-container>
  </div>
</div>